import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import ExternalLink from 'components/external-link';

import { SHARED_LIST_BORDER_BOTTOM_COLOR } from './constants';

const opaqueStyles = css`
  transition: box-shadow 0.3s;
  background-color: ${Styles.color.cardBackground};
  box-shadow: ${Styles.boxShadow};
  border-radius: ${Styles.borderRadius};
  border-bottom: none;

  &:hover {
    box-shadow: ${Styles.boxShadow}, ${Styles.boxShadow};
  }
`;

const sharedStyles = css`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: inherit;
  min-height: 100%;
  padding: 0;
  text-decoration: none;
  border-radius: ${Styles.borderRadius};
`;

const opaqueListStyles = css`
  transition: box-shadow 0.3s;
  border-bottom: 1px solid ${Styles.color.grey.five};

  ${Styles.desktop`
    background-color: ${Styles.color.cardBackground};
    border-bottom: none;
    border-radius: ${Styles.borderRadius};
    box-shadow: ${Styles.boxShadow};

    &:hover {
      box-shadow: ${Styles.boxShadow}, ${Styles.boxShadow};
    }
  `}
`;

const sharedListStyles = css`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: inherit;
  min-height: 100%;
  padding: 0;
  text-decoration: none;
  border-bottom: 1px solid ${SHARED_LIST_BORDER_BOTTOM_COLOR};

  ${Styles.desktop`
    border-bottom: none;
    border-radius: ${Styles.borderRadius};
  `}
`;

export const TileLink = styled(Link)<{ $transparent: boolean }>`
  ${sharedStyles}
  ${({ $transparent }) => ($transparent ? null : opaqueStyles)};
`;

export const TileLinkExternal = styled(ExternalLink)`
  ${sharedStyles}
  ${opaqueStyles}
`;

export const TileListLink = styled(Link)<{
  $transparent: boolean;
}>`
  ${sharedListStyles}
  ${({ $transparent }) => ($transparent ? null : opaqueListStyles)};
  border-bottom: 1px solid ${SHARED_LIST_BORDER_BOTTOM_COLOR};
`;

export const TileListLinkExternal = styled(ExternalLink)`
  ${sharedListStyles}
  ${opaqueListStyles}
`;
